<template lang="pug">
.header(v-if="!whiteLabel" @click="handleHeaderClick")
  .logo-wrapper
    #open-left.side-nav-btn(@click="toggle()")
      img(src='images/header/menu-open.svg' alt='')
    router-link.logo(to="/lobby")
      img(v-if="cnyMode" :src="logoCNYPath")
      img(v-else-if="xmasMode" :src="logoXMASPath")
      img(v-else-if="wcMode" :src="logoWCPath")
      img(v-else :src="logoPath")
  .userpart
    .username-wrapper
      .username
        span.username-text {{ displayName }}
      .balance
        span.currency {{ currency_code }}
        | {{ available_balance }}
.header-api-site(v-else @click="handleHeaderClick")
  .userpart
    .username-wrapper
      .username
        span.username-text {{ displayName }}
      .balance
        span.currency {{ currency_code }}
        | {{ available_balance }}



//- #toolbar(:class="{ 'apiTop': whiteLabel }")
//-   a#open-left(v-if="!whiteLabel" href="javascript:void(0);" @click="toggle()")
//-     img(src="/images/nav-icon.svg")
//-   router-link#logo-swipe.logo(v-if="!whiteLabel" to="/lobby")
//-     img(v-if="cnyMode" :src="logoCNYPath")
//-     img(v-else-if="xmasMode" :src="logoXMASPath")
//-     img(v-else :src="logoPath")
//-   //- .userpart(:class="{ 'apiHeader': whiteLabel }")
//-   //-   .username-wrapper
//-   //-     .username
//-   //-       .user-id {{ displayName }}
//-   //-     .balance
//-   //-       span.currency.mr-1 {{ currency_code }}
//-   //-       span {{ available_balance }}
//-   //-   .user-icon
//-   //-     i.fas.fa-user
//-   .userpart(v-if="whiteLabel")
//-     .username
//-       .user-id {{ displayName }}
//-     .balance
//-       span.currency.mr-1 {{ currency_code }}
//-       span {{ available_balance }}
//-   .userpart(v-else)
//-     .username-wrapper
//-       .username
//-         .user-id {{ displayName }}
//-       .balance
//-         span.currency.mr-1 {{ currency_code }}
//-         span {{ available_balance }}
//-     .user-icon
//-       i.fas.fa-user
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import ClickOutside from "vue-click-outside";
import config from "@/config";

export default {
  directives: {
    ClickOutside
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    logoPath() {
      return config.logoPath;
    },
    wcMode() {
      return config.wcMode;
    },
    logoWCPath() {
      return config.logoWCPath;
    },
    cnyMode() {
      return config.cnyMode;
    },
    xmasMode() {
      return config.xmasMode;
    },
    logoCNYPath() {
      return config.logoCNYPath;
    },
    logoXMASPath() {
      return config.logoXMASPath;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    displayName() {
      if (this.nickname) return this.nickname;
      else return this.account_id;
    },
    account_id() {
      return this.$store.getters.accountId;
    },
    nickname() {
      return this.$store.getters.nickName;
    },
    wallet() {
      if (this.$store.getters.playerWallet) return this.$store.getters.playerWallet;
      return null;
    },
    balance() {
      return this.$store.getters.balance;
    },
    currency_code() {
      if (this.wallet["currency_code"]) {
        return this.wallet.currency_code.replace('UST', 'USDT');
      }
      return "-";
    },
    available_balance() {
      if (this.wallet) {
        return this.$numeral(this.balance).format("0,0.[00]");
      }
      return "-";
    }
  },
  destroyed() {
    EventBus.$off("GET_BALANCE", this.busGetBalance);
    clearInterval(this.populateBalance);
    // Clean up overlay click handler
    $(document).off('click', '.overlay');
  },
  mounted() {
    this.populateBalance();
    setInterval(this.populateBalance, 60000);
    EventBus.$on("GET_BALANCE", this.busGetBalance);
    EventBus.getBalance = this.busGetBalance;
    
    // Set up overlay click handler using event delegation
    this.$nextTick(() => {
      $(document).off('click', '.overlay').on('click', '.overlay', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeSidebar();
      });
    });
  },
  methods: {
    lobby() {},
    busGetBalance() {
      clearInterval(this.populateBalance);
      this.populateBalance();
    },
    toggle(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      $('body').toggleClass('open-side-nav');
    },
    closeSidebar() {
      $('body').removeClass('open-side-nav');
    },
    isSidebarOpen() {
      return $('body').hasClass('open-side-nav');
    },
    handleHeaderClick(e) {
      const target = e.target;
      const isMenuButton = target.closest('#open-left') || target.closest('.side-nav-btn');
      const isLogo = target.closest('.logo') || target.closest('a[to="/lobby"]');
      
      if (!isMenuButton && !isLogo && this.isSidebarOpen()) {
        this.closeSidebar();
      }
    },
    populateBalance(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        this.$store.dispatch("user/getBalance").then(
          res => {
            this.loading = false;
            if (res.success) {
              if (callback) callback();
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    }
  }
};
</script>
